import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  formType: 'add' | 'edit'
  updateFormType: (formType: 'add' | 'edit') => void
  isView: boolean
  updateIsView: (isView: boolean) => void
}

export const ShippingFormModalContext = createContext<IContext>({
  formType: 'add',
  updateFormType: () => {},
  isView: false,
  updateIsView: () => {},
})

export const ShippingFormModalContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [formType, setFormType] = useState<'add' | 'edit'>('add')
  const [isView, setIsView] = useState(false)

  const updateFormType = (formType: 'add' | 'edit') => {
    setFormType(formType)
  }

  const updateIsView = (isView: boolean) => {
    setIsView(isView)
  }

  return (
    <ShippingFormModalContext.Provider
      value={{
        formType,
        isView,
        updateFormType,
        updateIsView,
      }}>
      {children}
    </ShippingFormModalContext.Provider>
  )
}
